// Componente: EditContactoEmergencia.jsx (basado en estructura JSON)
import React from "react";
import Input from "../../../Elements/Input/Input";

const EditContactoEmergencia = ({ values, handleChange }) => {
    return (
        <div className="seccion-formulario">
            <h4>Contacto de Emergencia</h4>
            <div className="row g-3">
                <div className="col-md-6">
                    <Input
                        value={values.contactoEmergenciaNombre}
                        label="Nombre"
                        onChange={handleChange("contactoEmergenciaNombre")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.contactoEmergenciaParentesco}
                        label="Parentesco"
                        onChange={handleChange("contactoEmergenciaParentesco")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.contactoEmergenciaTelefono}
                        label="Teléfono"
                        onChange={handleChange("contactoEmergenciaTelefono")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.contactoEmergenciaTelefonoAlterno}
                        label="Teléfono alterno"
                        onChange={handleChange("contactoEmergenciaTelefonoAlterno")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.contactoEmergenciaDireccion}
                        label="Dirección"
                        onChange={handleChange("contactoEmergenciaDireccion")}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditContactoEmergencia;
